import Vue from "vue";
import VueSSE from "./utilities/sse";
import VueRx from "vue-rx";
import vuetify from "./plugins/vuetify";
import "./plugins/notifier";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "./registerServiceWorker";
import Axios from "axios";
import {DrawerLayout} from "vue-drawer-layout";

/* AG Grid */
import {LicenseManager} from "@ag-grid-enterprise/core";

const AGGridLicense = 'Using_this_{AG_Grid}_Enterprise_key_{AG-063010}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Dealio_Ltd}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Dealio}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Dealio}_need_to_be_licensed___{Dealio}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{6_September_2025}____[v3]_[01]_MTc1NzExMzIwMDAwMA==c63ef514986f751e70a10b1aa14e2e7b';
LicenseManager.setLicenseKey(AGGridLicense);

/* UTILITIES */
import {refineBaseURI} from "@/utilities/client-uri";


Vue.config.productionTip = false;

const refinedBaseURI = refineBaseURI(); // Check for client name presence in URL

Axios.defaults.baseURL = refinedBaseURI;

Vue.use(VueSSE);
Vue.use(VueRx);

Vue.component(DrawerLayout.name, DrawerLayout);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/worker.js').then(registration => {
    console.log('SW registered: ', registration);
  }).catch(registrationError => {
    console.log('SW registration failed: ', registrationError);
  });
}

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // Check if the click was outside the element and its children
      if (!(el === event.target || el.contains(event.target))) {
        // If so, call the method provided in the directive's value
        if (typeof vnode.context[binding.expression] === "function") {
          vnode.context[binding.expression](event);
        }
      }
    };
    // Attach this listener to the document
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    // Remove the event listener from the document when the bound element is unbound
    document.removeEventListener('click', el.clickOutsideEvent);
  },
});

const vm = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");